import { EnvironmentOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import type { MapMarker } from '@/utils/dashboardMap';
import { formatInr } from '@/utils/currency';
import styles from '../../Dashboard.module.scss';

interface MapMarkerPopupProps {
  marker: MapMarker;
}

export function MapMarkerPopup({ marker }: MapMarkerPopupProps) {
  return (
    <div className={styles.mapMarkerPopup}>
      <div className={styles.mapMarkerPopupHeader}>
        <EnvironmentOutlined />
        <strong>{marker.city}</strong>
      </div>
      <div className={styles.mapMarkerPopupStats}>
        <span>
          <ShoppingCartOutlined /> {marker.orders} orders
        </span>
        <span>{formatInr(marker.revenue)}</span>
      </div>
      <div className={styles.mapMarkerPopupArrow} />
    </div>
  );
}
